/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

export default class SelectDropDown extends React.Component {
    static get propTypes() {
        return {
            backspace: PropTypes.bool,
            className: PropTypes.string,
            clearable: PropTypes.bool,
            default: PropTypes.object,
            name: PropTypes.string.isRequired,
            onChange: PropTypes.func,
            options: PropTypes.array.isRequired,
            placeholder: PropTypes.string,
            isSearchable: PropTypes.bool
        };
    }

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        return <div className={this.props.className}>
            <Select
                backspaceRemoves={this.props.backspace || false}
                className="basic-single"
                classNamePrefix="select"
                clearable={this.props.clearable || false}
                name={this.props.name}
                onChange={this.onChange}
                options={this.props.options}
                placeholder={this.props.placeholder}
                searchable={this.props.isSearchable || false}
                value={this.props.default}/>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/shareModal/Select.js